import { useNavigate } from "react-router-dom";
import Header from "../header";
import Router from "../../../routes";
import { useAddDispatch, useAppSelector } from "../../../store";
import { useEffect, useState } from "react";
import Footer from "../footer";
import WelcomePopup from "../../welcomePopup";
function MainLayout() {
    const dispatch = useAddDispatch();
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);
    const [globalSearchPopup, setGlobalSearchPopup] = useState(false);

    const handleNavFunc = async (redirectTo: any) => {
        navigate(redirectTo);
    }
    return (
        <>
            <Header
                handleNavFunc={handleNavFunc}
                showLogin={showLogin}
                setShowLogin={setShowLogin}
                globalSearchPopup={globalSearchPopup}
                setGlobalSearchPopup={setGlobalSearchPopup}
            />
            <Router
                showLogin={showLogin}
                setShowLogin={setShowLogin}
            />
            <Footer
                globalSearchPopup={globalSearchPopup}
                setGlobalSearchPopup={setGlobalSearchPopup}
            />
            {/* <WelcomePopup /> */}
        </>
    );
};

export default MainLayout